import React from 'react';
import './privacy.scss';

const PrivacyWrapper: React.FC = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>מדיניות פרטיות</h1>
        <p className="privacy-updated">עודכן לאחרונה: {new Date().toLocaleDateString('he-IL')}</p>

        <section className="privacy-section">
          <h2>1. מבוא</h2>
          <p>
            FB Zipper ("אנחנו", "שלנו" או "החברה") מכבדת את פרטיות המשתמשים בשירותיה.
            מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים, מאחסנים ומגנים על המידע שלך
            בעת השימוש בשירותינו.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. המידע שאנו אוספים</h2>
          <p>אנו עשויים לאסוף את סוגי המידע הבאים:</p>

          <h3>מידע שאתה מספק לנו:</h3>
          <ul>
            <li>פרטי התחברות (שם משתמש, סיסמה, כתובת אימייל)</li>
            <li>פרטי חשבון פייסבוק (לצורך התחברות והפעלת השירות)</li>
            <li>תוכן שאתה מעלה למערכת (פוסטים, תמונות, סרטונים)</li>
            <li>הגדרות קמפיינים וקבוצות</li>
            <li>פרטי תשלום (מעובדים באמצעות ספק תשלומים מאובטח)</li>
          </ul>

          <h3>מידע שנאסף אוטומטית:</h3>
          <ul>
            <li>כתובת IP</li>
            <li>סוג דפדפן ומכשיר</li>
            <li>נתוני שימוש ופעילות במערכת</li>
            <li>עוגיות (Cookies) ומזהים דומים</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. כיצד אנו משתמשים במידע</h2>
          <p>אנו משתמשים במידע שנאסף למטרות הבאות:</p>
          <ul>
            <li>הפעלת השירות ומתן גישה לתכונותיו</li>
            <li>ניהול חשבון המשתמש שלך</li>
            <li>עיבוד תשלומים וחיובים</li>
            <li>שיפור ופיתוח השירות</li>
            <li>תקשורת עמך בנוגע לשירות, עדכונים ותמיכה</li>
            <li>אבטחת השירות ומניעת הונאות</li>
            <li>עמידה בדרישות חוקיות</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. שיתוף מידע עם צדדים שלישיים</h2>
          <p>אנו לא מוכרים את המידע האישי שלך. אנו עשויים לשתף מידע עם:</p>
          <ul>
            <li><strong>פייסבוק/מטא:</strong> לצורך הפעלת השירות והתחברות לחשבונך</li>
            <li><strong>ספקי שירות:</strong> חברות המספקות לנו שירותים (אחסון, תשלומים, תמיכה)</li>
            <li><strong>רשויות חוק:</strong> כאשר נדרש על פי חוק או צו בית משפט</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>5. אבטחת מידע</h2>
          <p>
            אנו נוקטים באמצעי אבטחה סבירים להגנה על המידע שלך, כולל:
          </p>
          <ul>
            <li>הצפנת נתונים בהעברה ובאחסון</li>
            <li>גישה מוגבלת למידע על בסיס צורך לדעת</li>
            <li>ניטור ובקרת אבטחה שוטפים</li>
          </ul>
          <p>
            עם זאת, אין שיטת העברה או אחסון באינטרנט בטוחה ב-100%, ואיננו יכולים להבטיח
            אבטחה מוחלטת.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. שמירת מידע</h2>
          <p>
            אנו שומרים את המידע שלך כל עוד חשבונך פעיל או כנדרש לספק לך שירותים.
            לאחר סגירת חשבון, אנו עשויים לשמור מידע מסוים לתקופה מוגבלת לצורך עמידה
            בדרישות חוקיות, יישוב מחלוקות ואכיפת הסכמים.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. זכויותיך</h2>
          <p>בהתאם לחוקי הפרטיות החלים, יש לך את הזכויות הבאות:</p>
          <ul>
            <li><strong>גישה:</strong> לבקש עותק של המידע האישי שלך</li>
            <li><strong>תיקון:</strong> לבקש תיקון מידע לא מדויק</li>
            <li><strong>מחיקה:</strong> לבקש מחיקת המידע שלך (בכפוף למגבלות חוקיות)</li>
            <li><strong>התנגדות:</strong> להתנגד לעיבוד מסוים של המידע שלך</li>
            <li><strong>ניוד:</strong> לקבל את המידע שלך בפורמט נפוץ</li>
          </ul>
          <p>
            למימוש זכויותיך, אנא צור איתנו קשר בכתובת: support@fbzipper.com
          </p>
        </section>

        <section className="privacy-section">
          <h2>8. עוגיות (Cookies)</h2>
          <p>
            אנו משתמשים בעוגיות ובטכנולוגיות דומות לצורך:
          </p>
          <ul>
            <li>שמירת העדפות המשתמש</li>
            <li>אימות והתחברות</li>
            <li>ניתוח שימוש ושיפור השירות</li>
          </ul>
          <p>
            באפשרותך לנהל את העדפות העוגיות דרך הגדרות הדפדפן שלך.
          </p>
        </section>

        <section className="privacy-section">
          <h2>9. קישורים לאתרים חיצוניים</h2>
          <p>
            השירות שלנו עשוי להכיל קישורים לאתרים חיצוניים. איננו אחראים למדיניות
            הפרטיות או לתוכן של אתרים אלה. אנו ממליצים לקרוא את מדיניות הפרטיות
            של כל אתר שאתה מבקר בו.
          </p>
        </section>

        <section className="privacy-section">
          <h2>10. שינויים במדיניות</h2>
          <p>
            אנו עשויים לעדכן מדיניות פרטיות זו מעת לעת. שינויים מהותיים יפורסמו
            באתר ו/או יישלחו אליך בהודעה. המשך השימוש בשירות לאחר שינויים אלה
            מהווה הסכמה למדיניות המעודכנת.
          </p>
        </section>

        <section className="privacy-section">
          <h2>11. יצירת קשר</h2>
          <p>
            לשאלות או בקשות בנוגע למדיניות פרטיות זו, ניתן לפנות אלינו:
          </p>
          <ul>
            <li>אימייל: support@fbzipper.com</li>
          </ul>
        </section>

        <div className="privacy-acceptance">
          <p>
            <strong>בעצם השימוש בשירות, הנך מאשר כי קראת והבנת מדיניות פרטיות זו.</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export { PrivacyWrapper };
